var _rect, _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleforms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1763_14768)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 0H3.6C1.61178 0 0 1.61177 0 3.6V20.4C0 22.3882 1.61178 24 3.6 24H20.4C22.3882 24 24 22.3882 24 20.4V3.6C24 1.61177 22.3882 0 20.4 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L16.3636 5.18182L14.0909 2Z",
    fill: "#673AB7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9102 17.4543H15.9102V16.5452H10.9102V17.4543ZM10.9102 11.9997V12.9088H15.9102V11.9997H10.9102ZM9.77379 12.4543C9.77379 12.8304 9.46811 13.1361 9.09197 13.1361C8.71584 13.1361 8.41016 12.8304 8.41016 12.4543C8.41016 12.0781 8.71584 11.7725 9.09197 11.7725C9.46811 11.7725 9.77379 12.0781 9.77379 12.4543ZM9.77379 14.727C9.77379 15.1031 9.46811 15.4088 9.09197 15.4088C8.71584 15.4088 8.41016 15.1031 8.41016 14.727C8.41016 14.3509 8.71584 14.0452 9.09197 14.0452C9.46811 14.0452 9.77379 14.3509 9.77379 14.727ZM9.77379 16.9997C9.77379 17.3759 9.46811 17.6816 9.09197 17.6816C8.71584 17.6816 8.41016 17.3759 8.41016 16.9997C8.41016 16.6236 8.71584 16.3179 9.09197 16.3179C9.46811 16.3179 9.77379 16.6236 9.77379 16.9997ZM10.9102 15.1816H15.9102V14.2725H10.9102V15.1816Z",
    fill: "#F1F1F1"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4883 7.05566L19.544 12.1102V7.45453L14.4883 7.05566Z",
    fill: "url(#paint0_linear_1763_14768)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0898 2V6.09091C14.0898 6.84432 14.7001 7.45455 15.4535 7.45455H19.5444L14.0898 2Z",
    fill: "#B39DDB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.36364 2C5.61364 2 5 2.61364 5 3.36364V3.47727C5 2.72727 5.61364 2.11364 6.36364 2.11364H14.0909V2H6.36364Z",
    fill: "white",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 21.8861H6.36364C5.61364 21.8861 5 21.2725 5 20.5225V20.6361C5 21.3861 5.61364 21.9997 6.36364 21.9997H18.1818C18.9318 21.9997 19.5455 21.3861 19.5455 20.6361V20.5225C19.5455 21.2725 18.9318 21.8861 18.1818 21.8861Z",
    fill: "#311B92",
    fillOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1763_14768",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 2,
    width: 15,
    height: 20
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0909 2H6.36364C5.61364 2 5 2.61364 5 3.36364V20.6364C5 21.3864 5.61364 22 6.36364 22H18.1818C18.9318 22 19.5455 21.3864 19.5455 20.6364V7.45455L14.0909 2Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1763_14768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4535 7.45446C14.7001 7.45446 14.0898 6.84423 14.0898 6.09082V6.20446C14.0898 6.95787 14.7001 7.56809 15.4535 7.56809H19.5444V7.45446H15.4535Z",
    fill: "#311B92",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1763_14768",
    x1: 267.3,
    y1: 50.4557,
    x2: 267.3,
    y2: 512.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311B92",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#311B92",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1763_14768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleforms);
export default __webpack_public_path__ + "static/media/googleforms.4fcf33c4160511306edc735acc034f37.svg";
export { ForwardRef as ReactComponent };